
import React from 'react'
import moment from "moment";
import { component_tool } from '@/tool'
let { WizModal } = component_tool
import { Cascader } from 'antd'

import { WizClassifySelect,WizAuthority, WizClassifySelectRe, WizTableForm } from '@/containers/common';
let componentName = 'ruleConfigureDetail'

export const numberValidator = (rule, value, callback) => {
  if (value || value ===0) {
          callback()
          return
  }
  callback('请输入产物')
}
const fieldToName = {
  outputFlag:"产物标识",
  outputId:"产物"
}
function getFieldName(name = '') {
  if(name){
    Object.keys(fieldToName).forEach( ( key)=> {
      if(name.indexOf(key)!=-1){
        name = fieldToName[key]
      }
  });
  }
  return name;
}
export const formValidator = (rule, value, callback) => {
  let name = ''
  if(rule && rule.field){
    name = getFieldName(rule.field);
  }
  if (value || value ==='0') {
    callback()
    return
}
callback(`请输入${name}`)
}


export const outputClassValidator = (rule, value, callback) => {
  if (value) {
      if (value instanceof Array && value.length > 0) {
          callback()
          return
      }
  }
  callback('请选择一项产物类型')
}

export const authValidator = (rule, value, callback) => {
  if (value) {
      if (value.groupId ) {
          callback()
          return
      }
      if (value.orgIds && value.orgIds.length) {
          callback()
          return
      }
      if (value.positionIds && value.positionIds.length) {
          callback()
          return
      }
      if (value.positionCategoryIds && value.positionCategoryIds.length) {
          callback()
          return
      }
      if (value.personIds && value.personIds.length) {
          callback()
          return
      }
  }
  callback('请选择推荐范围')
}
export  function  _tableFormProps(entityType) {
    let config = { columns: [], tableApi: {} }
    let other = {
        selectType: 'radio'
    }
    switch (entityType) {
        case 0:
            config = WizTableForm.Config.program()
            break
        case 1:
            config = WizTableForm.Config.exam()
            break
        case 2:
            break
        case 3:
            break
        case 4:
            config = WizTableForm.Config.topic()
            break
        case 5:
            config = WizTableForm.Config.activity()
            break
        case 6:
            break
        case 8:
            config = WizTableForm.Config.offlineProgram()
            break    
        case 24:
          other.disabled = true
            break
        case 32:
          config = WizTableForm.Config.pathStage()
            break
        case 16:
          config = WizTableForm.Config.trainPathComment()
            break    
        default:
          other.disabled = true
    }
    let tableFormProps = {
        ...config,
        ...other
    }
    return tableFormProps
}
export const options = [
    {
      code: -1,
      name: '平台行为',
      items: [
        {
          code: 0,
          name: '登录',
        },
        {
          code: 1,
          name: '新手任务',
        },
      ],
    },
    {
      code: -2,
      name: '社区行为',
      items: [
        {
          code: 2,
          name: '发帖',
        },
        {
          code: 3,
          name: '点赞',
        },
        {
          code: 4,
          name: '评论',
        },
        {
          code: 5,
          name: '转发',
        },
        {
          code: 6,
          name: '活动任务',
        },
        {
          code: 13,
          name: '踩贴',
        },
      ],
    },
    {
      code: -3,
      name: '学习行为',
      items: [
        {
          code: 7,
          name: '课程学习',
        },
        {
          code: 8,
          name: '路径学习',
        },
        {
          code: 9,
          name: '考试',
        },
        {
          code: 10,
          name: '直播',
        },
        {
          code: 11,
          name: '班级任务',
        },
        {
          code: 12,
          name: '问卷调查',
        },
        {
          code: 14,
          name: '路径评语',
        },
        {
          code: 15,
          name: '考试通过',
        },
      ],
    },
  ];
    ;
